import Button from '@components/button/Button';

type ToggleGroupOption = {
  id: string;
  label: string;
};

type ToggleGroupProps = {
  options: ToggleGroupOption[];
  selectedId: string;
  onChange: (option: ToggleGroupOption) => void;
  className?: string;
};

const ToggleGroup = ({
  options,
  selectedId,
  onChange,
  className
}: ToggleGroupProps) => (
  <div
    role="tablist"
    aria-orientation="horizontal"
    className={`inline-flex items-center gap-1 rounded-lg border border-[#E4E4E4] bg-[#F4F4F4] p-1 ${
      className || ''
    }`}
  >
    {options.map((option) => {
      const isActive = option.id === selectedId;
      return (
        <Button
          key={option.id}
          variant="tertiary"
          size="none"
          label={option.label}
          labelStyle="!font-normal"
          className={`px-3 py-2 text-sm leading-[1.2857] text-[#010814] transition-colors ${
            isActive
              ? 'border border-[#E4E4E4] bg-white'
              : 'border border-transparent bg-transparent'
          }`}
          handleClick={() => onChange(option)}
        />
      );
    })}
  </div>
);

export default ToggleGroup;
